export const YARA_ID = 'yara';
